import { render, staticRenderFns } from "./TaskOrderDetail.vue?vue&type=template&id=43448948&scoped=true&"
import script from "./TaskOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TaskOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./TaskOrderDetail.vue?vue&type=style&index=0&id=43448948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43448948",
  null
  
)

export default component.exports